// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__nJIs7","texts":"Projects_texts__tpv8T","list":"Projects_list__tuCc-"};